module.exports = __webpack_public_path__ + "img/menu.1a0dbc6c.svg";